import { TreeviewModule }  from "ngx-treeview";

export const ExportModule = [
    TreeviewModule.forRoot()
];
